import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { IconButton } from '@mui/material';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TAB_NAME } from '@/components/DataGenerationHistory/constants';
import { downloadHistoryStore } from '@/stores/downloadHistoryStore';
import { styles } from './styles';

export const DataGenerationHistoryButton = () => {
  const setOpen = downloadHistoryStore.use.setOpen();
  const toggleOpen = downloadHistoryStore.use.toggleOpen();

  const { downloadsPane } = useParams<{ downloadsPane?: string }>();

  useEffect(() => {
    setOpen(downloadsPane === 'open');
  }, [downloadsPane, setOpen]);

  return (
    <IconButton onClick={toggleOpen} data-testid='download-history-icon' aria-label={TAB_NAME}>
      <CloudDownloadOutlinedIcon sx={styles.downloadIcon} />
    </IconButton>
  );
};
